import { placePageIconContainerClass } from '@tableau/data-catalog-shared';
import * as React from 'react';

export type PlacePageIconContainerProps = {
  readonly title: string;
};

export class PlacePageIconContainer extends React.Component<PlacePageIconContainerProps> {

  public render(): JSX.Element {
    return (
      <div className={placePageIconContainerClass} title={this.props.title}>
        {this.props.children}
      </div>
    );
  }

}
